import { Color } from '@kite-js/theme-types';

const grayScale: Color = {
    50: '#f9f9fa',
    100: '#e9ebee',
    200: '#dddfe2',
    300: '#d7d7db',
    400: '#90949c',
    500: '#2a2a2e',
};

export default grayScale;
